export interface MockInterceptOverride {
  body?: any;
  params?: any;
  mockUrl: string;
  delay: number;
}

export interface MockIntercept {
  url: string;
  method: string;
  mockUrl: string;
  delay?: number;
  overrides?: Array<MockInterceptOverride>;
}

export class MockInterceptConfig {
  intercepts: Array<MockIntercept>;
  resourceServer: string;

  constructor(interceptorConfigInjected: MockIntercept[], resourceServer: string) {
    this.intercepts = interceptorConfigInjected;
    this.resourceServer = resourceServer;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mock/http-mock.types.ts